import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const VatRateList = (props: PickerListProps<server.dto.VatRate>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedVatRateInstruction>({
    keyword: "",
    page: 1,
    perPage: 15,
  });

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="vatRateList"
    api={window.CoreApi.VatRate.Paginated}
    onClick={props.onItemSelected}

    getError={(query) => query.data?.pages.flatMap(p => "errors" in p && p.errors).join(", ") ?? ""}

    getId={vat => vat.vatRateId}
    renderListItem={vat => <>
      <div>{vat.internalName} ({vat.percentageFormatted})</div>
      <SubLabel>vatRateId: {vat.vatRateId}</SubLabel>
    </>}
  />;
};

export default VatRateList;